import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getA3ArticuloColumns = async () => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/articulos/columns`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const searchA3Articulos = async (
  q,
  dbSource = "STAGE_DESIGN",
  limit = 25
) => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/articulos`, {
    params: { q, limit, dbSource },
    headers: authHeaders(),
  });
  return response.data;
};

export const getA3Caracteristicas = async (
  numcar,
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/caracteristicas`, {
    params: { numcar, dbSource },
    headers: authHeaders(),
  });
  return response.data;
};

export const getA3Proveedores = async (
  q = "",
  dbSource = "STAGE_DESIGN",
  limit = 2000
) => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/proveedores`, {
    params: { q, limit, dbSource },
    headers: authHeaders(),
  });
  return response.data;
};

/** Ficha proveedor A3 (dirección, NIF, forma de pago) para PDF pedido compra. */
export const getA3ProveedorFichaPdf = async ({
  codpro,
  idPedc,
  dbSource = "STAGE_DESIGN",
}) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/proveedores/ficha`,
    {
      params: {
        codpro: codpro ?? "",
        idPedc: idPedc ?? "",
        dbSource,
      },
      headers: authHeaders(),
    }
  );
  return response.data;
};

/** Descripción artículo (DESCART) en A3. */
export const getA3ArticuloDescripcion = async (
  codart,
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/articulos/descripcion`,
    {
      params: { codart: codart ?? "", dbSource },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const getA3Clientes = async (q = "", dbSource = "STAGE_DESIGN") => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/clientes`, {
    params: { q, limit: 300, dbSource },
    headers: authHeaders(),
  });
  return response.data;
};

export const getA3CentrosCosteAnaliticos = async (
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/centros-coste-analiticos`,
    { params: { dbSource }, headers: authHeaders() }
  );
  return response.data;
};

export const getA3ClienteCentrosAnaliticos = async (
  codcli,
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/cliente-centros-analiticos`,
    { params: { codcli, dbSource }, headers: authHeaders() }
  );
  return response.data;
};

export const getA3PedidoCentrosCabecera = async ({
  idPedc,
  idPedv,
  dbSource = "STAGE_DESIGN",
}) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/pedido-centros-cabecera`,
    {
      params: {
        idPedc: idPedc ?? "",
        idPedv: idPedv ?? "",
        dbSource,
      },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const getA3FamiliasTalla = async (q = "", dbSource = "STAGE_DESIGN") => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/familias-talla`, {
    params: { q, limit: 300, dbSource },
    headers: authHeaders(),
  });
  return response.data;
};

export const getA3FamiliasTallaClasificadas = async (
  q = "",
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/familias-talla-clasificadas`,
    {
      params: { q, limit: 400, dbSource },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const getA3Tallas = async (
  codFamTalla,
  q = "",
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(`${API_URL}/api/produccion/a3/tallas`, {
    params: { codFamTalla, q, limit: 500, dbSource },
    headers: authHeaders(),
  });
  return response.data;
};

/** Líneas LINEPEDI con tallas para rellenar la rejilla al editar un pedido. */
export const getA3PedidoLineasMatriz = async ({
  idPedc,
  idPedv,
  codart,
  dbSource = "STAGE_DESIGN",
  fallbackByPedido = false,
}) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/pedidos/lineas-matriz`,
    {
      params: {
        idPedc: idPedc ?? "",
        idPedv: idPedv ?? "",
        codart: codart ?? "",
        dbSource,
        fallbackByPedido: fallbackByPedido ? 1 : 0,
      },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const createA3Articulo = async (fields, dbSource = "STAGE_DESIGN") => {
  const response = await axios.post(
    `${API_URL}/api/produccion/a3/articulos`,
    { fields, dbSource },
    { headers: authHeaders() }
  );
  return response.data;
};

export const updateA3Articulo = async (
  codart,
  fields,
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.put(
    `${API_URL}/api/produccion/a3/articulos/${encodeURIComponent(codart)}`,
    { fields, dbSource },
    { headers: authHeaders() }
  );
  return response.data;
};

export const getA3ArticuloPedidosUsage = async (
  codart,
  dbSource = "STAGE_DESIGN"
) => {
  const response = await axios.get(
    `${API_URL}/api/produccion/a3/articulos/${encodeURIComponent(codart)}/pedidos-usage`,
    {
      params: { dbSource },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const deleteA3Articulo = async (codart, dbSource = "STAGE_DESIGN") => {
  const response = await axios.delete(
    `${API_URL}/api/produccion/a3/articulos/${encodeURIComponent(codart)}`,
    {
      data: { dbSource },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const createA3Pedidos = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/produccion/a3/pedidos`,
    payload,
    { headers: authHeaders() }
  );
  return response.data;
};

export const getPresupuestoA3Pedidos = async (proyectoId, presupuestoId) => {
  const response = await axios.get(
    `${API_URL}/api/proyectos/${proyectoId}/presupuestos/${presupuestoId}/a3-pedidos`,
    { headers: authHeaders() }
  );
  return response.data;
};

/** Listado global de vínculos CRM–A3 (últimos `limit` por fecha de alta). */
export const getAllPresupuestoA3Pedidos = async (options = {}) => {
  const opts =
    typeof options === "number" ? { limit: options } : options || {};
  const params = { limit: opts.limit ?? 500 };
  if (opts.fechaDesde) params.fechaDesde = opts.fechaDesde;
  if (opts.fechaHasta) params.fechaHasta = opts.fechaHasta;
  if (opts.fechaCampo) params.fechaCampo = opts.fechaCampo;
  const response = await axios.get(`${API_URL}/api/presupuestos/a3-pedidos-todos`, {
    params,
    headers: authHeaders(),
  });
  return response.data;
};

export const updateA3Pedidos = async (payload) => {
  const response = await axios.put(
    `${API_URL}/api/produccion/a3/pedidos`,
    payload,
    { headers: authHeaders() }
  );
  return response.data;
};

export const deleteA3Pedidos = async (payload) => {
  const response = await axios.delete(`${API_URL}/api/produccion/a3/pedidos`, {
    headers: authHeaders(),
    data: payload,
  });
  return response.data;
};
